'use client';

import {useId} from 'react';

type BooleanFieldProps = {
  value: unknown;
  onChange: (value: boolean) => void;
  error?: string;
  disabled?: boolean;
  label: string;
  required?: boolean;
};

export function BooleanField({
  value,
  onChange,
  error,
  disabled,
  label,
  required,
}: BooleanFieldProps) {
  const id = useId();
  return (
    <div>
      <label
        htmlFor={id}
        className="flex items-center gap-2 text-sm font-medium text-gray-700"
      >
        <input
          id={id}
          type="checkbox"
          checked={Boolean(value)}
          onChange={(e) => {
            onChange(e.target.checked);
          }}
          disabled={disabled}
          className="rounded border-gray-300"
        />
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>
      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}
